import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=eb7f7ab2&scoped=true&"
import script from "./CouponItem.vue?vue&type=script&lang=ts&"
export * from "./CouponItem.vue?vue&type=script&lang=ts&"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=eb7f7ab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7f7ab2",
  null
  
)

export default component.exports